import type { ChatService } from '@repo/common/types/Chat';
import { currentDraft } from '@repo/ui/src/stores/draft.store';

// Load config early in app initialization
setTimeout(() => {
	void (async () => {
		try {
			const { loadConfig } = await import('@repo/sharedlib/src/stores/config');
			await loadConfig();
			const { initializeLogMetadata } = await import('@repo/sharedlib/src/utils/log-metadata');
			initializeLogMetadata(currentDraft);
		} catch (error) {
			console.error('Error loading config:', error);
		}
	})();
}, 0);

// @ts-ignore defining
if (typeof window !== 'undefined' && !window.loadChatService) {
	window.loadChatService = async () => {
		const { getChatService } = await import('@repo/sharedlib/src/chat-service-client');
		return (await getChatService()) as ChatService;
	};
}
